import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { formatMoney } from 'shared/util/formatting';
import type { Money } from 'shared/util/money';

interface PriceDetailProps {
    title: string;
    money: Money;
    extraPriceInformation?: {
        description: string;
        link: {
            text: string;
            url: string;
        };
    };
}

export const PriceDetail = ({ title, money, extraPriceInformation }: PriceDetailProps) => {
    const [showExtraPriceInformation, setShowExtraPriceInformation] = useState(false);

    const handleTitleClick = () => {
        setShowExtraPriceInformation(!showExtraPriceInformation);
    };

    return (
        <div>
            {title === 'Totalpris' && <hr className="divider" />}
            <p className={`grid grid-cols-3 gap-16 my-8 ${title === 'Totalpris' && 'font-bold'}`}>
                {extraPriceInformation ? (
                    <Button link className="col-span-2 m-0 cursor-pointer s-text text-14 text-left" onClick={handleTitleClick}>
                        {title}
                    </Button>
                ) : (
                    <span className="col-span-2 m-0 text-left">{title}</span>
                )}
                <data value={money.value} className="text-right">
                    {formatMoney(money, 0)}
                </data>
            </p>
            {showExtraPriceInformation && (
                <p className="text-left text-12 s-text-subtle pb-10">
                    {extraPriceInformation?.description}
                    {extraPriceInformation?.link && (
                        <Button link href={extraPriceInformation.link.url} target="_blank" rel="noreferrer">
                            {extraPriceInformation.link.text}
                        </Button>
                    )}
                </p>
            )}
        </div>
    );
};
